import PropTypes from "prop-types";
import { useRouter } from "next/router";
import classNames from "classnames";
import classes from "./upgradePlanModal.module.scss";
import Image from "next/image";
import { IMAGE_BASE_PATH } from "@/config/config";
import { toAmount } from "@/helpers/utils";
import { Button } from "@/components/core/form";
import { useDispatch } from "react-redux";
import { setUpSell } from "@/features/quote/quoteSlice";

const UpgradePlanModal = ({
  nextPageUrl,
  toggleUpgradePlanModal,
  upSellPlan,
  originalPremium,
}) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const premium = upSellPlan?.memberPremium[0]?.policySchemeSumInsured;
  const diff = toAmount(
    Math.round(upSellPlan?.totalPremium) - Math.round(originalPremium)
  );

  const handleUpSellPlanClk = (event, type) => {
    dispatch(
      setUpSell({
        isUpSell: type,
        sumInsured: type
          ? upSellPlan.memberPremium[0].policySchemeSumInsured
          : 0,
        premium: type ? upSellPlan.totalPremium : originalPremium,
      })
    );
    event.preventDefault();
    router.push(nextPageUrl);
    toggleUpgradePlanModal();
  };

  return (
    <div
      className={classNames(
        "d-flex flex-column justify-content-center px-2",
        classes.TextColor
      )}
    >
      <div className="upgradePlan">Upgrade Plan</div>
      <div className="row">
        <div className="col-12 col-md-7">
          <div
            className={classNames(
              classes.note,
              classes.textLight,
              "d-flex mt-3 align-items-start"
            )}
          >
            <Image
              src={`${IMAGE_BASE_PATH}/images/noun-light-bulb.svg`}
              alt={"nightBulb"}
              width={18}
              height={18}
              className="me-2"
            />
            <div>
              <span className={classNames(classes.textweightstyle)}>
                Did You Know :{" "}
              </span>
              Hospitalization costs are on the rise! Which is why we recommend
              that you upgrade your coverage amount
            </div>
          </div>
        </div>
        <div className="col-12 col-md-5 mt-md-3">
          <Image
            src={`${IMAGE_BASE_PATH}/images/health_upsell.svg`}
            alt={"Up Sell Popup"}
            width={179}
            height={85}
            className="mDisplayNone"
          />
        </div>
      </div>
      <div className="mt-4 mb-1">
        <div className={classNames(classes.premiumupselltext)}>
          Would You Like To Increase Your Sum Insured To &nbsp;
          <span className={classNames(classes.textweightstyle)}>
            <Image
              src={`${IMAGE_BASE_PATH}/images/rupeeblue.svg`}
              alt={"ErrorSvgD"}
              width={7}
              height={10}
            />
            &nbsp;{toAmount(Math.round(premium))}&nbsp;
          </span>
          For Just
          <span className={classNames(classes.textweightstyle)}>
            &nbsp;
            <Image
              src={`${IMAGE_BASE_PATH}/images/rupeeblue.svg`}
              alt={"ErrorSvgD"}
              width={7}
              height={10}
            />
            &nbsp;{diff}&nbsp;
          </span>
          More?
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-6">
          <Button
            type="button"
            className="w-100 mt-3"
            style={{ color: "#264a9f" }}
            secondary={true}
            active={false}
            bottomFixed={false}
            onClick={(event) => {
              handleUpSellPlanClk(event, false);
            }}
          >
            No, I’m Fine
          </Button>
        </div>
        <div className="col-12 col-md-6">
          <Button
            type="button"
            className="w-100 mt-3"
            bottomFixed={false}
            onClick={(event) => {
              handleUpSellPlanClk(event, true);
            }}
          >
            Yes, Proceed to Pay
          </Button>
        </div>
      </div>
    </div>
  );
};

UpgradePlanModal.propTypes = {
  nextPageUrl: PropTypes.string,
  originalPremium: PropTypes.string,
  toggleUpgradePlanModal: PropTypes.func,
  upSellPlan: PropTypes.object,
};

export default UpgradePlanModal;
